<template>
  <div id="hoverComponentsForProductCenter">
    <div class="menuCenter">
      <ul class="list">
        <li class="marli_name">城市智慧停车运营</li>
        <li class="width_201"></li>
        <router-link v-for="cuntry in cunTry" :key="cuntry.name" :to="{path:cuntry.path,query:{active:cuntry.active}}">
          <li class="item">
            {{cuntry.name}}
          </li>
        </router-link>
      </ul>
      <ul class="list">
        <li class="marli_name">封闭式停车场管理</li>
        <li class="width_201 mar_100"></li>
        <router-link v-for="opvalue in optionpark" :key="opvalue.name" :to="{path:opvalue.path}">
          <li class="item">
            {{opvalue.name}}
          </li>
        </router-link>
        <router-link v-for="park in parkfees" :key="park.name" :to="{path:park.path}">
          <li class="item">
            {{park.name}}
          </li>
        </router-link>
        <router-link v-for="other in Other" :key="other.name" :to="{path:other.path}">
          <li class="item">
            {{other.name}}
          </li>
        </router-link>
      </ul>
      <ul class="listname_ul">
        <li class="marli_name">新能源充电桩管理</li>
        <li class="width_201 mar_100"></li>
        <router-link v-for="item in ProductCenter" :key="item.name" :to="{path:item.path,query:{active:item.active}}">
          <li class="item">
            {{item.name}}
          </li>
        </router-link>
      </ul>
      <!-- <ul class="listname_ul">
        <router-link v-for="item in ProductCenter" :key="item.name" :to="{path:item.path,query:{active:item.active}}">
          <li class="item">
            {{item.name}}
          </li>
        </router-link>
      </ul> -->
    </div>

    <ul class="valuename_ul">
      <h4 class="title">智能硬件</h4>
    </ul>
    <ul class="list_tree">
      <li v-for="tree in productTree" :key="tree.id" @click="handleClick(tree)">
        <img :src="tree.pic_file">
        <p class="name highlight">{{tree.name}}</p>
      </li>
    </ul>
  </div>
</template>
<script>
import { getProTree } from '@/api/portal';
export default {
  data() {
    return {
      productTree: [],
      id: '',
      ProductCenter: [
        {
          name: '新能源充电桩运营管理平台',
          path: '/product/newenergy',
          active: '1',
        },
        {
          name: '新能源充电站经营管理系统',
          path: '/product/newenergy',
          active: '2',
        },
        {
          name: '企业充电服务系统',
          path: '/product/newenergy',
          active: '3',
        },
      ],
      optionpark: [
        {
          name: '停车场综合管理运营平台',
          path: '/product/operation',
        },
      ],
      parkfees: [
        {
          name: '停车场收费管理系统',
          path: '/product/parkfees',
        },
      ],
      Other: [
        {
          name: '其他停车场辅助系统',
          path: '/product/Other',
        },
      ],
      cunTry: [
        // {
        //   name: '城市智慧停车运营管理平台',
        //   active: '4',
        //   path: '/product/cuntry',
        // },
        {
          name: '城市道路停车收费巡检管理软件',
          active: '5',
          path: '/product/cuntry',
        },
        {
          name: '市民车主停车服务应用',
          active: '6',
          path: '/product/cuntry',
        },
      ],
    };
  },
  created() {
    this._getprotree();
  },
  methods: {
    _getprotree() {
      getProTree({})
        .then(res => {
          this.productTree = res.data;
        })
        .catch(err => {});
    },
    handleClick(tree) {
      this.$router.push({
        path: '/product/znYj',
        query: { id: tree.id },
      });
    },
  },
};
</script>

<style lang="scss">
@import '../variable.scss';
#hoverComponentsForProductCenter {
  color: #000000;
  font-size: 14px;
  line-height: 14px;
  padding-top: 56px;
  padding-bottom: 30px;
  .list {
    display: block;
    height: 152px;
    width: 506px;
    // margin-right: 91px;
    li {
      flex: 1;
      &:first-child {
        margin-left: 0;
      }
      .top-col {
        display: flex;
        flex-direction: column;
        span {
          color: $normal-font-color;
          font-size: 14px;
          margin-bottom: 20px;
          cursor: pointer;
        }
      }
      .name {
        cursor: pointer;
      }
      .highlight:hover {
        color: $highlight-font-color;
      }
    }
  }
  .listname_ul a {
    display: block;
    margin-top: 24px;
    white-space: nowrap;
    font-size: 14px;
    text-decoration: none;
    color: #000000;
    opacity: 0.72;
  }
  .marli_name {
    color: #0f2347;
    font-size: 16px;
    padding-bottom: 24px;
  }
  .width_201 {
    width: 201px;
    height: 2px;
    border-bottom: 1px solid #edecec;
  }
  .title_ul,
  .menuCenter {
    width: 1176px;
    margin: 0 auto;
    display: flex;
  }
  .title_ul li {
    font-size: 16px;
    color: #0f2347;
    white-space: nowrap;
  }
  .title_ul .mar_100 {
    margin-left: 376px;
  }
  .title_ul .mar_141 {
    margin-left: 204px;
  }
  .title {
    font-size: 16px;
    font-weight: normal;
    color: #0f2347;
    border-bottom: 1px solid #edecec;
    padding-bottom: 20px;
    height: 35px;
  }
  .list li {
    display: block;
  }
  .valuename_ul {
    width: 1176px;
    margin: 0 auto;
    padding-top: 64px;
  }
  img {
    width: 64px;
    height: 64px;
    margin-left: 12px;
  }
  .list a {
    display: block;
    margin-top: 24px;
    white-space: nowrap;
    font-size: 14px;
    text-decoration: none;
    color: #000000;
    opacity: 0.72;
  }
  .list a:hover,
  .listname_ul a:hover {
    color: #ff5100;
  }
  a {
    text-decoration: none;
  }
  .list_tree {
    width: 1176px;
    margin: 0 auto;
    display: inline-block;
    cursor: pointer;
    height: 120px !important;
  }
  .list_tree li:nth-child(1),
  .list_tree li:nth-child(2),
  .list_tree li:nth-child(3),
  .list_tree li:nth-child(4) {
    width: 272px;
    display: inline-block;
    margin-top: 24px;
    // margin-right: 48px;
  }
  .list_tree p:nth-child(1),
  .list_tree p:nth-child(2),
  .list_tree p:nth-child(3),
  .list_tree p:nth-child(4) {
    width: 80px;
    white-space: nowrap;
    text-align: -webkit-center;
    text-align: center;
    text-align: -moz-center;
  }
  .list_tree li:nth-child(5) {
    display: inline-block;
  }
  .list_tree li img {
    opacity: 0.64;
  }
  .list_tree li img:hover {
    opacity: 1;
  }
  .name {
    margin-top: 8px;
    font-size: 14px;
  }
}
</style>
